export default __webpack_public_path__ + "static/media/Ellipse 9.2695aa3b.png";